import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	descriptionTypography: {
		marginBottom: theme.spacing.small,
	},
	container: {
		display: 'flex',
		flexDirection: 'column',
	},
	paragraphsContainer: {
		/** Ugly selector to set the last child to have no margin so the toggle button aligns nice */
		':last-of-type :last-child': {
			marginBottom: 0,
		},
	},
}));
